import React from 'react';

export const QueryCNPJIcon = ({ className }) => {
	return (
		<svg width="32" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_28_817)">
				<path d="M26.0362 6.1625L27.8446 7.9125L11.3888 23.8375L4.15542 16.8375L5.96375 15.0875L11.3888 20.3375L26.0362 6.1625ZM26.0362 2.625L11.3888 16.8L5.96375 11.55L0.5 16.8375L11.3888 27.375L31.5 7.9125L26.0362 2.625Z" fill="#5F5F5F"/>
			</g>
			<defs>
				<clipPath id="clip0_28_817">
					<rect width="31" height="30" fill="white" transform="translate(0.5)"/>
				</clipPath>
			</defs>
		</svg>
	);
};
